module.exports = __webpack_public_path__ + "media/images/logo_epic-6640f2e5.png";